// =============================================================================
// ModifierEffectRow — displays one ModifierEffect inside a ModifierCard
// =============================================================================
import type { ModifierEffect } from '../../../../backend/shared/types/index';

interface Props {
  effect: ModifierEffect;
  bonusTypeName: string;
}

export default function ModifierEffectRow({ effect, bonusTypeName }: Props) {
  // Roll modifier effect (advantage / disadvantage)
  if (effect.rollModifier) {
    const isAdv = effect.rollModifier === 'advantage';
    return (
      <div className="flex items-baseline gap-1.5 text-xs">
        <span className={`font-semibold ${isAdv ? 'text-success' : 'text-danger'}`}>
          {isAdv ? '▲ Advantage' : '▼ Disadvantage'}
        </span>
        <span className="text-parchment/80">on {effect.targetLabel}</span>
        {effect.condition && (
          <span className="text-parchment-muted/40 italic">({effect.condition})</span>
        )}
      </div>
    );
  }

  // Numeric bonus effect
  const sign   = (effect.value ?? 0) >= 0 ? '+' : '';
  const colour = (effect.value ?? 0) >= 0 ? 'text-success' : 'text-danger';

  return (
    <div className="flex items-baseline gap-1.5 text-xs">
      <span className={`font-mono font-bold tabular-nums ${colour}`}>
        {sign}{effect.value}
      </span>
      <span className="text-parchment-muted/50">{bonusTypeName}</span>
      <span className="text-parchment/80">to {effect.targetLabel}</span>
      {effect.condition && (
        <span className="text-parchment-muted/40 italic">({effect.condition})</span>
      )}
    </div>
  );
}
